import { api } from '../lib/axios'
import type { ResponseAPI } from '../types/response-api.type'

export type Seller = {
  codigo: number
  vendedor: string
}

export type SellersListResponse = ResponseAPI

export const adminSellersListService = async (): Promise<SellersListResponse> => {
  const response = await api.get<SellersListResponse>('/vendedor')
  return response.data
}
